import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapGetters({
      xmppMessagingJoinIdToJid: 'xmppMessaging/joinIdToJid',
    }),
  },
  methods: {
    ...mapActions({
      xmppMessagingForwardMessageBySeq: 'xmppMessaging/forwardMessageBySeq',
      xmppMessagingSendMessage: 'xmppMessaging/sendMessage',
    }),
  },
});
